export default __webpack_public_path__ + "sound/warning.2db47b39d75c36d7bd384e0bb65774dc.mp3";